var _g, _text, _text2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Apple_Store",
    "data-name": "Apple Store",
    xmlns: "http://www.w3.org/2000/svg",
    width: 213,
    height: 64,
    viewBox: "0 0 213 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0H203a10,10,0,0,1,10,10V54a10,10,0,0,1-10,10H10A10,10,0,0,1,0,54V10A10,10,0,0,1,10,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 1 C 5.037384033203125 1 1 5.037387847900391 1 10 L 1 54 C 1 58.96261215209961 5.037384033203125 63 10 63 L 203 63 C 207.9626159667969 63 212 58.96261215209961 212 54 L 212 10 C 212 5.037387847900391 207.9626159667969 1 203 1 L 10 1 M 10 0 L 203 0 C 208.5228271484375 0 213 4.477165222167969 213 10 L 213 54 C 213 59.52283477783203 208.5228271484375 64 203 64 L 10 64 C 4.4771728515625 64 0 59.52283477783203 0 54 L 0 10 C 0 4.477165222167969 4.4771728515625 0 10 0 Z",
    stroke: "none",
    fill: "#979797"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Download_on_the",
    "data-name": "Download on the",
    transform: "translate(68 26)",
    fill: "#545454",
    fontSize: 15,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "0.08em"
  }, "Download on th"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "e"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "App_Store",
    "data-name": "App Store",
    transform: "translate(68 50)",
    fill: "#545454",
    fontSize: 20,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "App Store"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logo",
    d: "M4.424,36.6C.81,31.4-1.949,21.9,1.762,15.486a10.293,10.293,0,0,1,8.7-5.253c2.717-.049,5.284,1.823,6.944,1.823s4.777-2.249,8.052-1.919a9.832,9.832,0,0,1,7.69,4.15,9.489,9.489,0,0,0-4.539,7.981,9.252,9.252,0,0,0,5.643,8.474A23,23,0,0,1,31.336,36.7c-1.755,2.555-3.57,5.094-6.436,5.147-2.821.053-3.725-1.663-6.944-1.663S13.728,41.8,11.065,41.9l-.144,0C8.224,41.908,6.163,39.1,4.424,36.6ZM17.07,9.659A8.754,8.754,0,0,1,19.3,3.174,9.455,9.455,0,0,1,25.5,0a9.219,9.219,0,0,1-2.19,6.693A7.982,7.982,0,0,1,17.5,9.675Q17.283,9.675,17.07,9.659Z",
    transform: "translate(16.823 11)",
    fill: "#4ca07a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleStore);
export default __webpack_public_path__ + "static/media/Apple-Store.64ed3f413f682c2f98f0ef790f915870.svg";
export { ForwardRef as ReactComponent };